import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3 font-bold rounded bg-brand5 text-brand1 hocus:bg-brand4 hocus:text-brand1 focus:shadow-outline focus:outline-none transition duration-300`;
